<div class="snackbar-wrapper">
    <h4>No Store Selected</h4>
    <p>To deliver at home, select a different store by clicking the store icon.</p>
</div>